import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "role",
    "permissionCheckbox",
    "permissionsSection",
    "fullPermissionsMessage",
  ];
  static values = {
    defaults: Object,
  };

  connect() {
    const anyChecked = this.permissionCheckboxTargets.some((cb) => cb.checked);
    this.handleRoleState(!anyChecked);
  }

  onRoleChange(event) {
    this.handleRoleState(true);
  }

  handleRoleState(isChange) {
    const role = this.roleTarget.value;
    const isFullPermissionRole = ["owner", "admin"].includes(role);

    if (isFullPermissionRole) {
      this.showFullPermissionsMessage();
      this.disableCheckboxes();
      this.checkAllCheckboxes();
    } else {
      this.hideFullPermissionsMessage();
      this.enableCheckboxes();
      if (isChange) {
        this.applyDefaults(role);
      }
    }
  }

  showFullPermissionsMessage() {
    if (this.hasFullPermissionsMessageTarget) {
      this.fullPermissionsMessageTarget.classList.remove("hidden");
    }
    if (this.hasPermissionsSectionTarget) {
      this.permissionsSectionTarget.classList.add("hidden");
    }
  }

  hideFullPermissionsMessage() {
    if (this.hasFullPermissionsMessageTarget) {
      this.fullPermissionsMessageTarget.classList.add("hidden");
    }
    if (this.hasPermissionsSectionTarget) {
      this.permissionsSectionTarget.classList.remove("hidden");
    }
  }

  disableCheckboxes() {
    this.permissionCheckboxTargets.forEach((checkbox) => {
      checkbox.disabled = true;
    });
  }

  enableCheckboxes() {
    this.permissionCheckboxTargets.forEach((checkbox) => {
      checkbox.disabled = false;
    });
  }

  checkAllCheckboxes() {
    this.permissionCheckboxTargets.forEach((checkbox) => {
      checkbox.checked = true;
    });
  }

  applyDefaults(role) {
    const defaults = this.defaultsValue[role];
    if (!defaults) {
      // If no defaults defined (e.g. some new role?), uncheck all or leave as is?
      // Unchecking seems safer as "reset".
      this.permissionCheckboxTargets.forEach(
        (checkbox) => (checkbox.checked = false),
      );
      return;
    }

    this.permissionCheckboxTargets.forEach((checkbox) => {
      // checkbox.name is like "user[organization_user_attributes][permissions_attributes][sanitation_read]"
      // We need to extract "sanitation_read"
      const match = checkbox.name.match(/\[(\w+)\]$/);
      if (match) {
        const permissionName = match[1];
        checkbox.checked = !!defaults[permissionName];
      }
    });
  }
}
